// extracted by mini-css-extract-plugin
module.exports =  {"tooltip":"_0d624b9a27--tooltip--M1G81","arrow_tooltip":"_0d624b9a27--arrow_tooltip--xm3aH","arrow":"_0d624b9a27--arrow--QDoVo"};